export default __webpack_public_path__ + "static/media/p10.04858162.jpg";